module.exports = __webpack_public_path__ + "fabe227f1ab3e7b147fdf7a101b1b758.woff";


//////////////////
// WEBPACK FOOTER
// ./markup/fonts/roboto/roboto-medium.woff
// module id = 1134
// module chunks = 0